import React from 'react';
import { LOGO_URL } from '../utils/blocks';
export function BrandFooter() {
  return <div className="footer-brand" data-id="element-42" data-mp="21aat90u9zhsi">
      <img src={LOGO_URL} alt="Carolina Gómez" data-id="element-43" data-mp="2199986va7kyn" />
      <div className="fb-text" data-id="element-44" data-mp="2f9tpowdq54oz">
        Elaborado por <b data-id="element-45" data-mp="2f8iq78rbaj3o">Carolina Gómez</b> · Estratega de Ventas como Negocio
        <br data-id="element-46" data-mp="2aaz1tg0wgpy0" />
        <a href="https://instagram.com/carolinagomez.estratega" target="_blank" rel="noopener noreferrer" data-id="element-47" data-mp="2aah7wq1pmnt9">
          @carolinagomez.estratega
        </a>
      </div>
    </div>;
}